/* eslint-disable import/no-unresolved */
import * as React from "react";

import { Switch, Route } from "react-router-dom";

import PrintWrapper from "Pages/QR/qrPage";

import FullPageLoader from "Components/UI/FullPageLoader";
import SoldQCSection from "Components/VehicleSummaryPage/SoldQC/SoldQC";

import Layout from "Shared/Layout";

const Home = React.lazy(() => import("Pages/VehicleListingPage"));
const VehicleOnBoardingForm = React.lazy(() => import("Pages/VehicleOnBoardingForm/VehicleOnBoardingForm"));
const VendorOverview = React.lazy(() => import("Pages/VendorOverview/VendorOverview"));
const VendorFormPage = React.lazy(() => import("Pages/vendorForm/index"));
const VehicleSummary = React.lazy(() => import("Pages/VehicleSummary/VehicleSummary"));
const AddServiceHistory = React.lazy(() => import("Pages/ServiceHistory/AddServiceHistory"));
const EditServiceHistory = React.lazy(() => import("Pages/ServiceHistory/EditServiceHistory"));
const FRFormPage = React.lazy(() => import("Pages/FinanceReceiptForm/FinanceReceipt"));
const PaymentForm = React.lazy(() => import("Pages/PaymentForm/EditPaymentHistory"));
const QCFormPage = React.lazy(() => import("Pages/QCForm/Forms"));
const PdfView = React.lazy(() => import("Pages/PdfView/PdfView"));
const RecallTool = React.lazy(() => import("Pages/RecallNew/RecallTool"));
const ReportsTool = React.lazy(() => import("Pages/Reports/ReportsTool"));
const RecallFormPage = React.lazy(() => import("Pages/RecallForm/index"));
const Warranty = React.lazy(() => import("Pages/Warranty/WarrantyTools"));
const VehiclePipeline = React.lazy(() => import("Pages/VehiclePipeline/VehiclePipeline"));
const MarketPlaceTools = React.lazy(() => import("Pages/MarketPlaceTools/MarketPlaceTools"));
const BulkUpload = React.lazy(() => import("Pages/BulkUpload/BulkUpload"));
const ViewBulkUploadFile = React.lazy(() => import("Pages/ViewBulkUploadFile/ViewBulkUploadFile"));
const Access = React.lazy(() => import("Pages/Access/Access"));
const RefurbTool = React.lazy(() => import("Pages/RefurbTool/RefurbTool"));
const PartsInventoryTool = React.lazy(() => import("Pages/PartsInventoryTool/PartsInventoryTool"));
const ReviewModule = React.lazy(() => import("Pages/ReviewModule/ReviewModule"));
const WorkOrderModule = React.lazy(() => import("Pages/WorkOrderModule"));
const GenerateInvoice = React.lazy(() => import("Pages/GenerateInvoice/GenerateInvoice"));
const UpdateCarCategory = React.lazy(() => import("Pages/UpdateCarCategory/UpdateCarCategory"));
const B2BPaymentPortal = React.lazy(() => import("Pages/B2BPaymentPortal/B2BPaymentPortal"));
const PaymentPortal = React.lazy(() => import("Pages/PaymentPortal/PaymentPortal"));

function Routes() {
  return (
    <React.Suspense fallback={<FullPageLoader />}>
      <Layout>
        <Switch>
          <Route exact path={["/", "/home"]} component={Home} />
          <Route exact path="/onboarding-form" component={VehicleOnBoardingForm} />
          <Route exact path="/onboarding-form/:leadId" component={VehicleOnBoardingForm} />
          <Route exact path="/vendor-form" component={VendorFormPage} />
          <Route exact path="/vendor-list" component={VendorOverview} />
          <Route exact path="/vehicle-summary/:leadId/sold-qc-images" component={SoldQCSection} />
          <Route exact path="/vehicle-summary/:leadId/:tab" component={VehicleSummary} />
          <Route
            exact
            path="/vehicle-summary/:leadId/data-validation/add-service-history"
            component={AddServiceHistory}
          />
          <Route
            exact
            path="/vehicle-summary/:leadId/data-validation/edit-service-history"
            component={EditServiceHistory}
          />
          <Route exact path="/payment-form/:leadId/:sourceId/:paymentId" component={PaymentForm} />
          <Route exact path="/payment-form/:leadId/:sourceId" component={PaymentForm} />
          <Route exact path="/finance-receipt/:leadId/:paymentId" component={FRFormPage} />
          <Route exact path="/finance-receipt/:leadId" component={FRFormPage} />
          <Route exact path="/quality-checkform/:leadId" component={QCFormPage} />
          <Route exact path="/recall-form" component={RecallFormPage} />
          <Route exact path="/recall/:tab" component={RecallTool} />
          <Route exact path="/recall" component={RecallTool} />
          <Route exact path="/reports/:tab" component={ReportsTool} />
          <Route exact path="/reports" component={ReportsTool} />
          <Route exact path="/invoice/:tab?" component={GenerateInvoice} />
          <Route exact path="/vas-car-category" component={UpdateCarCategory} />
          <Route exact path="/qr-page" component={PrintWrapper} />
          <Route exact path="/file/:fileName" component={PdfView} />
          <Route exact path="/warranty" component={Warranty} />
          <Route exact path="/warranty/:tab" component={Warranty} />
          <Route exact path="/vehicle-pipeline" component={VehiclePipeline} />
          <Route exact path="/marketplace-tools" component={MarketPlaceTools} />
          <Route exact path="/marketplace-tools/:tab" component={MarketPlaceTools} />
          <Route exact path="/bulk-upload" component={BulkUpload} />
          <Route exact path="/bulk-upload/view-file/:fileId" component={ViewBulkUploadFile} />
          <Route exact path="/access" component={Access} />
          <Route exact path="/refurb/:tab" component={RefurbTool} />
          <Route exact path="/refurb" component={RefurbTool} />
          <Route path="/parts/:tab/:subtab?" component={PartsInventoryTool} />
          <Route exact path="/review" component={ReviewModule} />
          <Route exact path="/workshop/:id" component={WorkOrderModule} />
          <Route exact path="/b2b-invoice" component={B2BPaymentPortal} />
          <Route exact path="/payment" component={PaymentPortal} />
        </Switch>
      </Layout>
    </React.Suspense>
  );
}

export default Routes;
